// Adds a "text slide" hover effect to all primary/secondary buttons.
// On hover the current label slides up and out while an identical copy
// slides in from below. On mouse-leave the motion reverses: the visible
// label slides down and a copy comes in from the top.
//
// The effect is applied only to buttons whose content is plain text, so
// icon buttons (add-to-cart, buy buttons, etc.) are left untouched.

const SELECTOR = '.button, .button-secondary';

/**
 * Wraps a single button's text label in the slide structure.
 * @param {HTMLElement} el
 */
function applySlide(el) {
  // Already processed.
  if (el.dataset.textSlide === 'true') return;

  // Skip add-to-cart buttons (they have their own icon/animation markup).
  if (el.closest('add-to-cart-component')) return;

  // Only handle buttons that contain plain text (no child elements such
  // as icons or nested spans).
  if (el.children.length > 0) return;

  const label = el.textContent.replace(/\s+/g, ' ').trim();
  if (label === '') return;

  el.dataset.textSlide = 'true';
  el.classList.add('has-text-slide');

  const slide = document.createElement('span');
  slide.className = 'btn-slide';

  const original = document.createElement('span');
  original.className = 'btn-slide__label btn-slide__label--original';
  original.textContent = label;

  const clone = document.createElement('span');
  clone.className = 'btn-slide__label btn-slide__label--clone';
  clone.setAttribute('aria-hidden', 'true');
  clone.textContent = label;

  slide.appendChild(original);
  slide.appendChild(clone);

  el.textContent = '';
  el.appendChild(slide);
}

function applyAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(applySlide);
}

// Initial pass.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => applyAll());
} else {
  applyAll();
}

// Re-apply when sections are re-rendered in the theme editor.
document.addEventListener('shopify:section:load', (event) => {
  applyAll(event.target);
});

// Re-apply for content added dynamically (quick add, cart drawer, AJAX, ...).
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      if (node.matches && node.matches(SELECTOR)) applySlide(node);
      if (node.querySelectorAll) applyAll(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
